import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=2c9a4230&scoped=true&"
import script from "./NoSidebar.vue?vue&type=script&lang=js&"
export * from "./NoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NoSidebar.vue?vue&type=style&index=0&id=2c9a4230&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a4230",
  null
  
)

export default component.exports